<template>
    <div class="object-block-company" :class="objectBlockClasses">
        <div class="object-block__main">
            <div class="object-block__header">
                <div class="object-block__header-title-container">
                    <CompassObject :object="objectType" :size="objectSize" />
                    <div>
                        <div class="object-block__header-name-container">
                            <BlockName :name="name" :link="linkCard" />
                            <CompassTooltip
                                :disabled="!typeLabel"
                                :content="typeLabel"
                                :arrow="false"
                                placement="top"
                            >
                                <TagThird :type="data.type" :label="typeLabel" size="extra-small" />
                            </CompassTooltip>
                        </div>
                        <div
                            v-if="variant === OBJECT_BLOCK_VARIANT.PREVIEW"
                            class="typographies-paragraph-caps-small-regular object-block__header-caption"
                        >
                            {{ objectCaption }}
                        </div>
                    </div>
                </div>
                <CompassIconButton
                    v-if="variant === OBJECT_BLOCK_VARIANT.LINKED"
                    icon="close"
                    @click="$emit('unlink')"
                />
            </div>
            <BlockDescriptionListPart
                v-if="displayDescriptionList && hasDescriptionListItem"
                v-bind="$props"
            />
        </div>
        <div v-if="$slots.contact" class="object-block__related-container">
            <slot name="contact" />
        </div>
    </div>
</template>

<script>
import BlockGeneric from 'vcomponents/common/object/BlockGeneric.vue';
import BlockDescriptionListPart from 'vcomponents/common/object/BlockDescriptionListPart.vue';
import { getFullNameUser } from 'Helpers/avatarHelper.js';
import ThirdTypeTags from 'Dictionaries/thirdTypeTags.js';
import TagThird from 'vcomponents/common/TagThird/TagThird.vue';

export default {
    components: { TagThird, BlockDescriptionListPart },
    extends: BlockGeneric,
    props: {
        isEmbedded: {
            type: Boolean,
            default: false,
        },
        showEmail: {
            type: Boolean,
            default: true,
        },
        showPhone: {
            type: Boolean,
            default: true,
        },
        showMobile: {
            type: Boolean,
            default: true,
        },
        showAddress: {
            type: Boolean,
            default: true,
        },
    },
    emits: ['edit', 'unlink'],
    data() {
        return {
            dotColor: '',
            objectType: 'company',
        };
    },
    computed: {
        hasDescriptionListItem() {
            return (
                (this.showEmail && !!this.data.email) ||
                (this.showPhone && !!this.data.phone_number) ||
                (this.showMobile && !!this.data.mobile_number) ||
                (this.showAddress && !!this.data.address)
            );
        },
        name() {
            return this.data.name ?? `${this.data.first_name} ${this.data.last_name}`;
        },
        objectBlockClasses() {
            return [
                this.isEmbedded ? 'object-block--embedded' : '',
                'object-block',
                `object-block--${this.variant}`,
            ];
        },
        typeLabel() {
            return ThirdTypeTags[this.data.type]?.label ?? '';
        },
        objectSize() {
            return this.isEmbedded ? 'extra-small' : 'small';
        },
    },
    created() {
        this.linkCard = this.getLink({
            id: this.getObjectId(),
            type: 'company',
            subtype: this.data.object ? this.data.object.sub_type : this.data.type,
        });

        this.objectCaption = this.data.address
            ? `${this.data.address.postal_code} ${this.data.address.city}`
            : '';

        if (this.data.contact) {
            this.data.contact.link = this.getLink({
                id: this.data.contact.id,
                type: 'people',
                subtype: 'people',
            });
            this.data.contact.fullName = getFullNameUser(this.data.contact, true);
        }
    },
};
</script>
<style lang="scss" scoped>
.object-block-company {
    .object-block-contact {
        margin-top: var(--spacing-3);
    }
}
</style>
